import { render, staticRenderFns } from "./AppNavigationHeaderNewEvent.vue?vue&type=template&id=673844b5&"
import script from "./AppNavigationHeaderNewEvent.vue?vue&type=script&lang=js&"
export * from "./AppNavigationHeaderNewEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/christoph/workspace/nextcloud/apps/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('673844b5')) {
      api.createRecord('673844b5', component.options)
    } else {
      api.reload('673844b5', component.options)
    }
    module.hot.accept("./AppNavigationHeaderNewEvent.vue?vue&type=template&id=673844b5&", function () {
      api.rerender('673844b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppNavigation/AppNavigationHeader/AppNavigationHeaderNewEvent.vue"
export default component.exports